<template>
  <div class="page-payment-success">
    <van-row justify="space-between">
      <van-col span="24">
        <div class="payment-box">
          <div class="payment-icon">
            <van-icon name="success" color="#fff" size="40" class="icon-success" />
          </div> 
          <div class="payment-title">
            <p class="pm-title" style="margin-bottom: 15px"> {{ $t("successfully") }}</p>
            <p class="pm-title-sub" v-if="data.title" style="text-align: center; max-width: 330px">
              {{ $t("purchase_one") }} {{ data.title }}
            </p>
          </div>
        </div>
      </van-col>
      <van-col span="24">
        <div class="payment-content">
          <div class="page-wapper">
            <div class="wapper-content">
              <div class="content">
                <ul>
                  <li style="color: #707070;"> {{ $t("subscribe_id") }}</li>
                  <li> {{ data.subcribeId }}</li>
                </ul>
                <ul>
                  <li style="color: #707070;">{{ $t("subscribe_date") }}</li>
                  <li>{{ data.subcribeDate }}</li>
                </ul>
                <ul>
                  <li style="color: #707070;">{{ $t("paid_from") }}</li>
                  <li> {{ formatPhoneNumberTwo(data.paidFrom) }}</li>
                </ul>
                <ul>
                  <li style="color: #707070;">{{ $t("total_amount") }}</li>
                  <li> {{ fixedPrice(data.price) }}{{ data.unit }}</li>
                </ul>
                <div v-if="data.content">
                  <hr class="card-line" />
                  <div class="card-description">
                    <div class="card-description-content" v-html="data.content"></div>
                    <!-- <div class="card-description-content" v-html="content"></div> -->
                  </div>
                </div>
              </div>
              <div class="footer-bill" style="">
                <img id="img-footer-bill" src="@/assets/images/buttomCut.svg" style="" alt="footer-bill"
                  class="img-footer-bill">
              </div>
            </div>
          </div>
        </div>
      </van-col>
      <van-col span="24" class="cs-btn-bill van-payment-success" style=" z-index: 999">
        <van-button @click="goHome" :color="color_primary()" block class="btn-home"> {{ $t("home") }}</van-button>
      </van-col>
    </van-row>
  </div>
</template>

<script src="./index.js"></script>

<style src="./index.css" lang="css" scoped></style>


<style>
.page-payment-success {
    width: 100%;
    min-height: 100vh;
}

.cs-icon-success {
    position: relative;
    z-index: 0;
}

.page-payment-success::before {
    content: "";
    display: block;
    position: absolute;
    top: 0%;
    left: 50%;
    width: 100%;
    height: 200px;
    background: #D2E1F7;
    border-radius: 50%;
    filter: blur(40px);
    transform: translate(-50%, -50%);
    z-index: 0;
}
</style>
